import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "semantic-ui-css/semantic.min.css";
import Root from "./root";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";
import store from "./store";



ReactDOM.render(
  <Provider store={store}>
    <Router basename={"/"}>
      <Root />
    </Router>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();

